module.exports = __webpack_public_path__ + "img/145.f20e82a2.jpg";